import { GetServerSideProps } from 'next';

import type { IGoodInCart } from 'entities/products';
import {normalizeCartGoods} from 'shared/lib/normalizers/normalizeGoods';
import checkAuth from '../global/api/auth';
import { useCartList } from 'shared/lib/hooks/useCartList';
import CartList from '../components/Cart/List';
import CartSidebar from '../components/Cart/Sidebar';

import { api } from '../global/api';
import styles from 'global/styles/Cart.module.scss';
import { Button } from '@nebo-team-dev/vobaza.ui.button';
import { CartFooter } from 'components/Cart/CartFooter';
import { checkProductToBuy, IProductError } from 'entities/products/lib/checkProductToBuy';
import { useRouter } from 'next/router';
import { useState } from 'react';

type Props = {
  withCountChange: string | boolean;
  initialPrice: number;
  initialGoods: IGoodInCart[];
  initialWeight: number;
};

export default function Cart(props: Props) {
  const {
    setOrderPrice,
    basketChanged,
    handleChangeGood,
    setIsCheckoutDisabled,
    handleError,
    orderPrice,
    isCheckoutDisabled,
    weight,
    goodsList,
  } = useCartList(props);

  const router = useRouter();
  const [productError, setProductError] = useState<IProductError>(null);

  const handleOrderTransit = async () => {
    for (let i = 0; i < goodsList.length; i++) {
      const goodItem = goodsList[i];

      const goodId = goodItem.product.id;

      const errorRes = await checkProductToBuy(goodId);
      if (errorRes) return setProductError(errorRes);
    }

    router.push('/checkout');
  };

  return (
    <div>
      <div className="container">
        <div className={styles.cartContainer}>
          <h2 className={styles.cartTitle}>Корзина</h2>
          <div className={styles.cartContent}>
            <div className={styles.cartContentBlock}>
              <CartList
                weight={weight}
                goods={goodsList}
                setOrderPrice={setOrderPrice}
                withCountChange={basketChanged}
                onChangeGoods={handleChangeGood}
                setIsCheckoutDisabled={setIsCheckoutDisabled}
                onErrorChangeGoods={handleError}
              />
              <div className={`${styles.cartSidebarCheckout} ${isCheckoutDisabled ? styles.disabled : ''}`}>
                <Button
                  text="Перейти к оформлению"
                  size="big"
                  isFullScreen
                  onClick={handleOrderTransit}
                  disabled={!goodsList.find((good) => good.isChecked)}
                />
              </div>
            </div>
            <div>
              <CartSidebar
                orderWeight={weight}
                productError={productError}
                price={orderPrice}
                goods={goodsList}
                isCheckoutDisabled={isCheckoutDisabled}
                onError={handleError}
                setProductError={setProductError}
              />
              <div
                className={`${styles.cartSidebarCheckout} ${isCheckoutDisabled ? styles.disabled : ''} ${
                  styles.mobileButtons
                }`}
              >
                <Button
                  text="Перейти к оформлению"
                  size="big"
                  isFullScreen
                  onClick={handleOrderTransit}
                  disabled={!goodsList.find((good) => good.isChecked)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <CartFooter
        isDisable={goodsList.filter(({ isChecked }) => isChecked).length === 0}
        callBack={handleOrderTransit}
        total={orderPrice}
        buttonText="Перейти к оформлению"
      />
    </div>
  );
}

export const getServerSideProps: GetServerSideProps<Props> = async ({ req }) => {
  let initialGoods = [];
  let initialPrice = 0;
  let withCountChange = '';
  let initialWeight = 0;

  try {
    await checkAuth(req, true);
    const cartRes = await api.getCart();
    const cart = cartRes.data.data;

    initialPrice = cart.order_price / 100;
    initialWeight = cart.order_weight / 1000;
    initialGoods = normalizeCartGoods(cart.products);

    if (cart.basket_changed) {
      withCountChange = cart.basket_changed;
    }
  } catch (error) {
    console.error(error);
    return {
      props: {
        initialGoods,
        initialPrice,
        withCountChange,
        initialWeight,
      },
    };
  }

  return {
    props: {
      initialGoods,
      initialPrice,
      withCountChange,
      initialWeight,
    },
  };
};
